module.exports = __webpack_public_path__ + "img/aftee-green.d238a127.png";